import {IStateMore} from './reducer';
import {IUserAgent} from '../../common/type';
import {
  createAction,
  createActionFetch,
  createBasicActions,
} from '../../common/util/redux';
import {IHistoryTab} from '../../commonSub/type';
import {
  IAddedCashItem,
  IAddedDaumCashItem,
  IAddedTicketItem,
  IMyNews,
  IThirdPartyTerm,
  IUsedCashItem,
  IUsedDaumCashItem,
  IUsedTicketItem,
  IWaitfreeContent,
} from '../type';

export enum ActionType {
  SetValue = 'more.SetValue',
  SetPropertyValues = 'more.SetPropertyValues',
  FetchCouponRegisterResult = 'more.FetchCouponRegisterResult',
  FetchServiceWithdrawal = 'more.FetchServiceWithdrawal',
  FetchInquiry = 'more.FetchInquiry',
  FetchToggleTerm = 'more.FetchToggleTerm',
  FetchThirdPartyTerms = 'more.FetchThirdPartyTerms',
  FetchMoreRedDotStatus = 'more.FetchMoreRedDotStatus',
  FetchMyNewsList = 'more.FetchMyNewsList',
  FetchWaitfreeList = 'more.FetchWaitfreeList',
  ConfirmMyNews = 'more.ConfirmMyNews',
  AddMyNewsList = 'more.AddMyNewsList',
  AddWaitfreeList = 'more.AddWaitfreeList',
  FetchDeleteWaitfree = 'more.FetchDeleteWaitfree',
  FetchMyNewsReceive = 'more.FetchMyNewsReceive',
  FetchCashHistory = 'more.FetchCashHistory',
  AddCashContents = 'more.AddCashContents',
  FetchTicketHistory = 'more.FetchTicketHistory',
  AddTicketContents = 'history.AddTicketContents',
  FetchDaumCashHistory = 'more.FetchDaumCashHistory',
  AddDaumCashContents = 'more.AddDaumCashContents',
}

export const actions = {
  ...createBasicActions<IStateMore>({
    setValueActionType: ActionType.SetValue,
    setPropertyValuesActionType: ActionType.SetPropertyValues,
  }),
  fetchCouponRegisterResult: (payload: {redeemCode: string}) =>
    createActionFetch(ActionType.FetchCouponRegisterResult, {
      payload,
    }),
  fetchServiceWithdrawal: () =>
    createActionFetch(ActionType.FetchServiceWithdrawal),
  fetchInquiry: (payload: {
    email: string;
    phoneNumber: string;
    inquiryContents: string;
    inquiryTitle: string;
    fileList?: File[];
    categoryId?: string;
    userAgent?: IUserAgent;
  }) => createActionFetch(ActionType.FetchInquiry, {payload}),
  fetchToggleTerm: (payload: IThirdPartyTerm) =>
    createActionFetch(ActionType.FetchToggleTerm, {
      payload,
    }),
  fetchThirdPartyTerms: () =>
    createActionFetch(ActionType.FetchThirdPartyTerms),
  fetchMoreRedDotStatus: () =>
    createActionFetch(ActionType.FetchMoreRedDotStatus),
  fetchMyNewsList: (isFirst?: boolean) =>
    createActionFetch(ActionType.FetchMyNewsList, {
      payload: {},
      isFirst,
    }),
  addMyNewsList: (myNewsList: IMyNews[], isFirst?: boolean) =>
    createAction(ActionType.AddMyNewsList, {myNewsList, isFirst}),
  fetchWaitfreeList: (isFirst?: boolean) =>
    createActionFetch(ActionType.FetchWaitfreeList, {
      payload: {},
      isFirst,
    }),
  addWaitfreeList: (waitfreeList: IWaitfreeContent[], isFirst?: boolean) =>
    createAction(ActionType.AddWaitfreeList, {waitfreeList, isFirst}),
  confirmMyNews: (id: string) => createAction(ActionType.ConfirmMyNews, {id}),
  fetchDeleteWaitfree: () => createActionFetch(ActionType.FetchDeleteWaitfree),
  fetchMyNewsReceive: (id: string, userAgent: IUserAgent) =>
    createActionFetch(ActionType.FetchMyNewsReceive, {
      payload: {id, userAgent},
    }),
  fetchCashHistory: (tab: IHistoryTab, isFirst?: boolean) =>
    createActionFetch(ActionType.FetchCashHistory, {
      payload: {tab},
      fetchKey: tab,
      isFirst,
    }),
  addCashContents: (
    data:
      | {
          tab: 'added';
          contents: IAddedCashItem[];
        }
      | {
          tab: 'used';
          contents: IUsedCashItem[];
        },
    isFirst?: boolean
  ) => createAction(ActionType.AddCashContents, {...data, isFirst}),
  fetchTicketHistory: (tab: IHistoryTab, isFirst?: boolean) =>
    createActionFetch(ActionType.FetchTicketHistory, {
      payload: {tab},
      fetchKey: tab,
      isFirst,
    }),
  addTicketContents: (
    payload:
      | {
          tab: 'added';
          contents: IAddedTicketItem[];
        }
      | {
          tab: 'used';
          contents: IUsedTicketItem[];
        },
    isFirst?: boolean
  ) => createAction(ActionType.AddTicketContents, {...payload, isFirst}),
  fetchDaumCashHistory: (tab: IHistoryTab, isFirst?: boolean) =>
    createActionFetch(ActionType.FetchDaumCashHistory, {
      payload: {tab},
      fetchKey: tab,
      isFirst,
    }),
  addDaumCashContents: (
    data:
      | {
          tab: 'added';
          contents: IAddedDaumCashItem[];
        }
      | {
          tab: 'used';
          contents: IUsedDaumCashItem[];
        },
    isFirst?: boolean
  ) => createAction(ActionType.AddDaumCashContents, {...data, isFirst}),
};
